import { FC, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useCart } from '~/data/cart';
import { CartAtom } from '~/services/cart';
import { Coupon } from '~/services/coupon';
import Button from '../Button';
import Input from '../Input';
import styles from './InputDiscount.module.scss';
import { AlertAtom } from '~/services/alerts';

interface InputDiscountProps {
    onChangeCoupon?: (coupon: Coupon) => void;
    loading?: boolean;
}

const InputDiscount: FC<InputDiscountProps> = ({ onChangeCoupon, loading }) => {
    const [coupon, setCoupon] = useState('');
    const [cart] = useRecoilState(CartAtom.cart);
    const cartSelector = useRecoilValue(CartAtom.cartSelector);
    const { applyCouponCode } = useCart();

    const handleAddCoupon = async () => {
        if (coupon) {
            await applyCouponCode({
                variables: {
                    cartId: cart.cartId,
                    couponCode: coupon
                }
            });
            setCoupon('');
        }
    };

    return (
        <div className={styles.input_discount}>
            <Input
                className="flex-1"
                placeholder="Enter coupon code"
                value={coupon}
                disabled={cartSelector.loadingApplyCouponCode}
                onChange={(e) => {
                    setCoupon(e.target.value);
                }}
                onKeyDown={(e) => e.key === 'Enter' && handleAddCoupon()}
            />
            <Button
                onClick={handleAddCoupon}
                disabled={cartSelector.loadingApplyCouponCode}
                loading={cartSelector.loadingApplyCouponCode}
            >
                Add
            </Button>
        </div>
    );
};

export default InputDiscount;
